"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceCarriageReturn = replaceCarriageReturn;
function replaceCarriageReturn(content) {
    return content ? content.replace(/[\r\n]/g, '') : '';
}
//# sourceMappingURL=replace-carriage-return.js.map